<template>
  <div>
    <!-- Container-fluid starts-->
    <div class="edit-profile">
      <div class="row">
        <div class="col-xl-4">
          <div class="card">
            <div class="card-header">
              <h4 class="card-title mb-0">Avatar</h4>
              <div class="card-options">
                <a class="card-options-collapse" href="#" data-toggle="card-collapse">
                  <i class="fe fe-chevron-up"></i>
                </a>
                <a class="card-options-remove" href="#" data-toggle="card-remove">
                  <i class="fe fe-x"></i>
                </a>
              </div>
            </div>
            <div class="card-body">
              <form name="upload_form">
                <div class="row mb-2">
                  <div class="col-auto">
                    <img class="img-70 rounded-circle" v-bind:src="userImg.url" />
                  </div>
                  <div class="col">
                    <h3 class="mb-1">{{ user.first_name }} {{ user.last_name }}</h3>
                    <p class="mb-4">{{ user.title }}</p>
                  </div>
                </div>
                <div class="btn btn-primary btn-block" @click="uploaderStart">Neues Bild</div>
                <transition name="fade">
                  <div class="uploadContainer" v-if="uploadClicked">
                    <input type="file" name="uploadFile" @change="fileChange" />
                    <button @click.prevent="startUpload" class="btn btn-primary btn-block">Upload</button>
                    <transition name="fade">
                      <div key="uploader" v-if="uploading">
                        <div class="progress">
                          <div
                            class="progress-bar progress-bar-striped"
                            role="progressbar"
                            :style="{ width: uploadProgress }"
                            aria-valuenow="10"
                            aria-valuemin="0"
                            aria-valuemax="100"
                          >
                            {{ uploadProgress }}
                          </div>
                        </div>
                      </div>
                    </transition>
                  </div>
                </transition>
              </form>
            </div>
          </div>
        </div>
        <div class="col-xl-8">
          <form class="card">
            <div class="card-header">
              <h4 class="card-title mb-0">Benutzerdaten</h4>
              <div class="card-options">
                <a class="card-options-collapse" href="#" data-toggle="card-collapse">
                  <i class="fe fe-chevron-up"></i>
                </a>
                <a class="card-options-remove" href="#" data-toggle="card-remove">
                  <i class="fe fe-x"></i>
                </a>
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-4">
                  <div class="form-group">
                    <label class="form-label">Company</label>
                    <input name="company" class="form-control" type="text" placeholder="Company" v-bind:value="user.company" @change="watchChanges" />
                  </div>
                </div>
                <div class="col-sm-4 col-md-4">
                  <div class="form-group">
                    <label class="form-label">Email address</label>
                    <input name="email" class="form-control" type="email" placeholder="Email" v-bind:value="user.email" @change="watchChanges" />
                  </div>
                </div>
                <div class="col-sm-4 col-md-4">
                  <div class="form-group">
                    <label class="form-label">Titel</label>
                    <input name="title" class="form-control" type="text" placeholder="Titel" v-bind:value="user.title" @change="watchChanges" />
                  </div>
                </div>
                <div class="col-sm-6 col-md-6">
                  <div class="form-group">
                    <label class="form-label">First Name</label>
                    <input
                      name="first_name"
                      class="form-control"
                      type="text"
                      placeholder="Vorname"
                      v-bind:value="user.first_name"
                      @change="watchChanges"
                    />
                  </div>
                </div>
                <div class="col-sm-6 col-md-6">
                  <div class="form-group">
                    <label class="form-label">Last Name</label>
                    <input
                      name="last_name"
                      class="form-control"
                      type="text"
                      placeholder="Last Name"
                      v-bind:value="user.last_name"
                      @change="watchChanges"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer text-right">
              <transition name="fade">
                <div class="newPw card-footer text-right" v-if="pwReset" @click.prevent="reqPwReset">
                  <button class="btn btn-warning">Rücksetzung anfordern</button>
                </div>
              </transition>
              <button class="btn btn-primary" @click.prevent="pwResetToggle" style="margin-right:10px;">Passwort ändern</button>
              <button class="btn btn-primary" type="submit" @click.prevent="updateUser">Profil aktualisieren</button>
              <transition name="fade">
                <div class="notices" v-if="pwResetRequest">Sie erhalten eine Email mit Anweisungen zur Rücksetzung Ihres Passworts.</div>
              </transition>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- Container-fluid Ends-->
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "AdminEditProfile",
  components: {},
  data() {
    return {
      uploadClicked: false,
      uploadFile: false,
      uploadBase64: false,
      uploading: false,
      updating: false,
      initialState: false,
      formChange: false,
      showPwNotSameError: false,
      changedValues: {},
      pwReset: false,
      pwResetRequest: false,
    };
  },
  computed: {
    ...mapGetters({
      user: "auth/user",
      userImg: "auth/userImg",
      uploadProgress: "auth/uploadProgress",
      toasted: "app/toasts",
    }),
  },
  created() {
    this.initialState = Object.assign({}, this.user);
  },
  methods: {
    pwResetToggle() {
      this.pwReset = this.pwReset ? false : true;
    },
    reqPwReset() {
      this.pwResetRequest = true;
      this.$store.dispatch("auth/reqPwReset", this.user.email);
      setTimeout(() => (this.pwResetRequest = false), 4000);
      setTimeout(() => (this.pwReset = false), 4000);
    },
    watchChanges(e) {
      let prop = e.target.name;
      let val = e.target.value;
      let isChanged = this.initialState[prop] == val ? false : true;

      if (isChanged) {
        this.changedValues[prop] = val;
      } else {
        delete this.changedValues[prop];
      }
      this.formChange = JSON.stringify(this.changedValues) !== "{}";
    },
    async updateUser() {
      if (!this.formChange) {
        this.$toasted.show("Keine Änderungen erkannt.", this.toasted.info);
        return;
      }
      let streamline = JSON.parse(JSON.stringify(this.changedValues));
      try {
        this.$store.dispatch("auth/initUpdateUser", streamline);
        await this.$store.dispatch("auth/mutateUser", this.user);
        this.$toasted.show("Profil aktualisiert", this.toasted.success);
      } catch (error) {
        console.log(error);
      }
    },
    uploaderStart() {
      this.uploadClicked = this.uploadClicked ? false : true;
    },
    fileChange(e) {
      this.uploadFile = e.target.files[0];
    },
    encodeImageFileAsURL(e) {
      e.preventDefault();
      let _this = this;
      var reader = new FileReader();
      reader.onloadend = function() {
        _this.uploadBase64 = reader.result;
        _this.startUpload();
      };
      reader.readAsDataURL(this.uploadFile);
    },
    async startUpload() {
      this.uploading = true;
      let image = new FormData();
      image.append("file", this.uploadFile);
      try {
        await this.$store.dispatch("auth/uploadImage", {
          image,
        });
        this.uploading = false;
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>

<style>
.uploadContainer {
  margin-top: 20px;
}

.progress {
  margin-top: 20px;
}

.uploadContainer input {
  padding: 10px;
}

.newPw {
  display: inline-block;
  padding: 0px 0px 0px 0px !important;
  margin: 0 10px 0 0;
}

.newPw .form-group .form-control,
.newPw .form-group .form-label {
  display: block;
}

.inline-input {
  display: inline-block;
  margin: 0px 0px 0px 10px;
}

.notices {
  display: block;
  padding: 20px;
  color: orange;
}
</style>
